<div class="wm-workspace">
  <div class="ftux-screen">
    <div class="ftux-screen-container ftux-workspace">
      <div class="screen-container">
        <div class="img-container">
          <img
            [src]="'assets/images/api_designer.svg' | versionManager"
            alt=""
          />
        </div>
        <h3 class="title">{{ locale.LABEL_IMPORT_APIS }}</h3>
        <h5>{{ locale.LABEL_API_DESIGNER_MESSAGE }}</h5>
        <button
          name="ci-datasource-data-model"
          class="btn button-primary"
          (click)="apiService.openImportDialog()"
        >
          <i class="wm-icon wms wms-plus"></i>{{ locale.LABEL_IMPORT_APIS }}
        </button>
      </div>
    </div>
  </div>
</div>
